import { css } from 'emotion'
// import { TEXT_COLOR_LIGHT, LINK_COLOR } from 'constants/styleConstants'

export const NotificationsSettingsMainStyles = css``
